import Alpine from 'alpinejs'
import {rfpForm} from './rfp'
import './swiper'
import './header'
import './phoneMask'
import './pageShare'
import './scrollToTop'
window.Alpine = Alpine
Alpine.data('rfpForm', rfpForm)
Alpine.start()
